// extracted by mini-css-extract-plugin
export var parcelRow = "_vf-0";